export default __webpack_public_path__ + "static/media/gallery_02.3e054a60.jpg";